import React from 'react';
import PropTypes from 'prop-types';

import { Spinner } from '../../base';
import { Grid, Cell } from '../../base/styled';

import {
  LabelWidget,
  ListWidget,
  NumberWidget,
} from '../../widgets';

const Dynapub = (props) => {

  // eslint-disable-next-line react/destructuring-assignment
  if (!props.results) {
    return <Spinner />;
  }
  const {
    results: {
      error = null,
      data: {
        'dyna-dead-count': dynaDeadCount = null,
        'dyna-dead-list': dynaDeadList = null,
        'dyna-mostly-count': dynaMostlyCount = null,
        'dyna-mostly-list': dynaMostlyList = null,
        'dyna-origin-list': dynaOriginList = null,
        'dyna-pub-list': dynaPubList = null,
      } = {},
    } = {},
  } = props;
  // Dead gets "danger" and mostly dead gets "error"... probably a cultural thing
  if (dynaDeadCount) {
    dynaDeadCount.className = 'danger-fill dark';
  }
  if (dynaMostlyCount) {
    dynaMostlyCount.className = 'error-fill dark';
  }
  return (
    <div className="dashboard">
      <Grid columns={6} gap="30px" rows="90px 200px 1fr" alignContent="stretch" height="inherit">
        <Cell width={6}>
          <h1>DYNAPUB STATUS</h1>
        </Cell>
        <Cell width={2}>
          <NumberWidget input={{ error, data: dynaDeadCount }} />
        </Cell>
        <Cell width={2}>
          <NumberWidget input={{ error, data: dynaMostlyCount }} />
        </Cell>
        <Cell>
          <LabelWidget input={{
            data: {
              title: 'MOSTLY DEAD',
              subtitle: 'BY STORAGE ID',
            },
          }}
          />
        </Cell>
        <Cell>
          <LabelWidget input={{
            data: {
              title: 'MOSTLY DEAD',
              subtitle: 'BY DYNAPUB',
            },
          }}
          />
        </Cell>
        <Cell width={2}>
          <ListWidget input={{ error, data: dynaDeadList }} />
        </Cell>
        <Cell width={2}>
          <ListWidget input={{ error, data: dynaMostlyList }} />
        </Cell>
        <Cell>
          <ListWidget input={{ error, data: dynaOriginList }} />
        </Cell>
        <Cell>
          <ListWidget input={{ error, data: dynaPubList }} />
        </Cell>
      </Grid>
    </div>
  );
};

Dynapub.defaultProps = null;

Dynapub.propTypes = {
  results: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({
      'dyna-dead-count': PropTypes.shape(NumberWidget.dataPropType),
      'dyna-dead-list': PropTypes.shape(ListWidget.dataPropType),
      'dyna-mostly-count': PropTypes.shape(NumberWidget.dataPropType),
      'dyna-mostly-list': PropTypes.shape(ListWidget.dataPropType),
      'dyna-origin-list': PropTypes.shape(ListWidget.dataPropType),
      'dyna-pub-list': PropTypes.shape(ListWidget.dataPropType),
    }),
  }),
};

export default Dynapub;
